/**
 * Onboarding Step Constants (Phase 1 freemium-redesign update)
 *
 * Athlete / non-athlete onboarding collapses to a single quickstart step:
 *   step 0..99  → quickstart (the new /onboarding/quickStart screen)
 *   step 100+   → onboarding complete → main app
 *
 * Staff onboarding keeps the legacy 200-220 sequence (unchanged).
 *
 * The named constants below are preserved for back-compat with any external
 * systems that referenced them and so the staging-refresh / log-analysis
 * tooling doesn't break. The GUARDIAN_PROFILE: 51 value was removed per
 * Phase 1 G1.
 */

export const ONBOARDING_STEPS = {
  FAMILY_SETUP: 10,
  SUBSCRIPTION: 20,
  INVITE_FAMILY_MEMBERS: 30,
  USER_TYPE: 40,
  ATHLETE_PROFILE: 50,
  // GUARDIAN_PROFILE removed (Phase 1 G1). Strategy B keeps the DB value
  // `user_type='guardian'`, but the step-51 form no longer exists.
  SCHOOL_INFO: 60,
  SPORT_INFO: 70,
  ACADEMIC_PERFORMANCE: 80,
  SPORT_PERFORMANCE: 85,
  PROFILE_PIC: 90,
  CONNECT_SOCIALS: 95,
  COMPLETE: 100,
  // Staff onboarding steps (200-series) — unchanged
  STAFF_PROFILE_SETUP: 200,
  STAFF_CONNECT_SOCIALS: 210,
  STAFF_COMPLETE: 220,
} as const;

/**
 * Step → screen helper. Simplified for the new freemium flow:
 *   0..99  → 'quickStart'
 *   100+   → 'matchingList' (main app)
 *   200..209 → 'staffOnboardingProfile'
 *   210..219 → 'staffOnboardingConnect'
 *   220+    → 'matchingList'
 */
export const getScreenForStep = (step: number): string => {
  if (step >= ONBOARDING_STEPS.STAFF_PROFILE_SETUP && step < ONBOARDING_STEPS.STAFF_CONNECT_SOCIALS) {
    return 'staffOnboardingProfile';
  }
  if (step >= ONBOARDING_STEPS.STAFF_CONNECT_SOCIALS && step < ONBOARDING_STEPS.STAFF_COMPLETE) {
    return 'staffOnboardingConnect';
  }
  if (step >= ONBOARDING_STEPS.COMPLETE) {
    return 'matchingList';
  }
  return 'quickStart';
};
